<template>
  <div id="app">
    <layout></layout>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    layout:()=>import('@/layout/index.vue')
  }
}
</script>

<style lang="scss">
@import './styles/main';
</style>